module.exports = __webpack_public_path__ + "img/Logo Name Lab Book - Blue.a3ccb98b.svg";